var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"loading-icon btn btn-sm",class:_vm.classes,attrs:{"type":"button","disabled":_vm.loading}},_vm.$listeners),[(_vm.loading)?_c('ProgressCircle',{staticClass:"side",attrs:{"tiny":"","color":"light"}}):_c('span',{staticClass:"material-icons"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }